import { getMissionByProgress } from "./storyProgression";

export const getActiveMissionFromProgress = (acts = [], progress = {}) => {
  if (!progress) return null;
  return getMissionByProgress({ acts }, progress);
};

export const missionWantsNpc = (mission, name) =>
  !!mission &&
  typeof mission.npc === "string" &&
  mission.npc.trim().toLowerCase() === String(name).toLowerCase();
